@if (compactMode === 'default' && brand === brandEnum.Titanium) {
  <div class="summary-container spacious">
    @if (!model?.IsRimless) {
      <div id="hasRim">
        <div class="font-medium">{{model?.Code}}</div>
        <div [innerHTML]="$safeNavigationMigration(modelSize?.Code) | replaceHash"></div>
      </div>
    }
    @if (model?.IsRimless) {
      <div id="isRimless">
        @if (!isDemo) {
          <div>{{'ENDUSER.GARNITURE'|translate}}</div>
        }
        @if (isDemo) {
          <div class="font-medium">{{model?.Code}}</div>
        }
        @if (isDemo) {
          <div [innerHTML]="$safeNavigationMigration(modelSize?.Hbox)"></div>
        }
      </div>
    }
    @for (componentGroup of groupedComponentSummaries; track componentGroup) {
      <div class="groupedComponentSummaries">
        @for (componentText of componentGroup; track componentText) {
          <div>
            @if (componentText) {
              <span>{{componentText | translate}}</span>
            }
          </div>
        }
      </div>
    }
    @if (configuration) {
      <div id="configuration">
        <span>{{configuration}}</span>
        @for (item of variantColorsToShow; track item) {
          @if (item.VariantColor) {
            <app-combined-color-name class="summary-inline-color" [color]="item.VariantColor.Color">
            </app-combined-color-name>
          }
        }
      </div>
    }
    @if (!configuration && variantColorsToShow.length > 0) {
      <div id="variantColorsToShow">
        @for (item of variantColorsToShow; track item) {
          @if (item.VariantColor) {
            <app-combined-color-name class="summary-inline-color" [color]="item.VariantColor.Color" [variantColor]="item.VariantColor"></app-combined-color-name>
          }
        }
      </div>
    }
  </div>
}

<!-- PRECIOUS -->
@if (compactMode === 'default' && brand === brandEnum.Precious) {
  <!-- COMPACT/SUMMARY -->
  @if (!showSummaryTable) {
    <div class="summary-container spacious">
      @if (!model?.IsRimless) {
        <div id="hasRim">
          <div class="font-medium">{{model?.Code}}</div>
          <div class="code" [innerHTML]="$safeNavigationMigration(modelSize?.Code) | replaceHash"></div>
        </div>
      }
      @if (model?.IsRimless) {
        <div id="isRimless">
          @if (!isDemo) {
            <div>{{'ENDUSER.GARNITURE'|translate}}</div>
          }
          @if (isDemo) {
            <div class="font-medium">{{model?.Code}}</div>
          }
          @if (isDemo) {
            <div [innerHTML]="$safeNavigationMigration(modelSize?.Hbox)"></div>
          }
        </div>
      }
      @for (componentGroup of groupedComponentSummaries; track componentGroup) {
        <div class="groupedComponentSummaries">
          @for (componentText of componentGroup; track componentText) {
            <div>
              @if (componentText) {
                <span>{{componentText | translate}}</span>
              }
            </div>
          }
        </div>
      }
      @if (configuration) {
        <div id="configuration">
          <span>{{configuration}}</span>
          @for (item of variantColorsToShow; track item) {
            @if (item.VariantColor) {
              <app-combined-color-name class="summary-inline-color" [color]="item.VariantColor.Color"></app-combined-color-name>
            }
          }
        </div>
      }
      @if (!configuration && variantColorsToShow.length > 0) {
        <div id="variantColorsToShow">
          @for (item of variantColorsToShow; track item) {
            @if (item.VariantColor) {
              <app-combined-color-name class="summary-inline-color" [color]="item.VariantColor.Color" [variantColor]="item.VariantColor"></app-combined-color-name>
            }
          }
        </div>
      }
    </div>
  }
  <!-- TABLE/DETAILS -->
  @if (showSummaryTable) {
    <div class="summary-container spacious">
      <table class="table m-5">
        <tr>
          <th>
            <div class="model-size mb-0">
              @if (!model?.IsRimless) {
                <span class="pr-2">{{model?.Code}}</span>
                <span class="" [innerHTML]="$safeNavigationMigration(modelSize?.Code) | replaceHash"></span>
              }
              @if (model?.IsRimless) {
                @if (!isDemo) {
                  <span>{{'ENDUSER.GARNITURE'|translate}}</span>
                }
                @if (isDemo) {
                  <span class="pr-2">{{model?.Code}}</span>
                }
                @if (isDemo) {
                  <span [innerHTML]="$safeNavigationMigration(modelSize?.Hbox)"></span>
                }
              }
            </div>
          </th>
          <th>{{'COMMON.DESCRIPTION'|translate}}</th>
          <th>{{'COMMON.SIZE'|translate}}</th>
          <th>{{'COMMON.COLOR'|translate}}</th>
        </tr>
        @for (variant of variantsToShow; track variant) {
          <tr>
            <!-- NAME COLUMN -->
            <td class="component-name" (click)="logVariantInfo(variant)">
              {{'CUSTOMIZER.COMPONENTS.' + variant.ComponentCode + '.NAME' | translate}}
            </td>
            <!-- DESCRIPTION -->
            <td>
              @if (!variant.ComponentVariantByPass) {
                {{variant.ComponentDescription | dataTranslate | translate }}
                {{variant.ComponentDescription2 | dataTranslate | translate }}
              }
              @if (variant.ComponentVariantOptional && (!variant.VariantSize)) {
                {{'COMMON.NONE' | translate}}
              }
            </td>
            <!-- SIZE COLUMN -->
            <td>
              @if (variant.ComponentVariantSizeDescription?.toLowerCase()?.indexOf('fixed') === -1) {
                {{variant.ComponentVariantSizeDescription}}
              }
              @if (variant.ComponentCode === 'TEMPLE') {
                ({{templeInclination === 0 ? 'c' : 'l'}})
              }
            </td>
            <!-- COLOR COLUMN -->
            <td class="component-color" title="{{$safeNavigationMigration(variant.VariantColor?.Color?.Description2) | dataTranslate | translate}}">
              @if (variant.ComponentCode !== 'BRIDGE_CLIP' && variant.VariantColor && variant.VariantColor.Color?.ColorLine?.Code) {
                <app-combined-color-name [color]="variant.VariantColor.Color" [variantColor]="variant.VariantColor" [forceDescriptionOnly]="variant.VariantColor.Color?.ColorLine?.Code !== 'HORN'"></app-combined-color-name>
              }
              @if (!variant.VariantColor && !variant.ComponentVariantByPass && !variant.ComponentVariantSizeBypass) {
                {{'CUSTOMIZER.COMPONENTS.COLOR.NOCOLOR' | translate}}
              }
            </td>
          </tr>
        }
        @if (!isDisplay) {
          <tr>
            <td class="component-name">{{'CUSTOMIZER.COMPONENTS.ENGRAVING.NAME' | translate}}</td>
            <td colspan="3">
              @if (engraving) {
                {{engraving}}
              }
            </td>
          </tr>
        }
      </table>
    </div>
  }
  <!--
  <div class="text-center" *ngIf="brand === brandEnum.Precious">
    <span class="pointer view-link" *ngIf="showSummaryTable" (click)="showSummaryTable = !showSummaryTable">{{'VIEW.SUMMARY' | translate}}</span>
    <span class="pointer view-link" *ngIf="!showSummaryTable" (click)="showSummaryTable = !showSummaryTable">{{'VIEW.DETAILS' | translate}}</span>
  </div> -->
}

@if (compactMode === 'compact' || compactMode === 'semi-compact' || compactMode === 'order-item') {
  <div class="summary-container compact">
    <div>
      @if (compactMode === 'order-item') {
        @if (!model?.IsRimless) {
          <div>
            <span [innerHTML]="$safeNavigationMigration(modelSize?.Code) | replaceHash"></span>
          </div>
        }
        @if (model?.IsRimless) {
          <div>
            @if (!isDemo) {
              <span>{{'ENDUSER.GARNITURE'|translate}}</span>
            }
            @if (isDemo) {
              <span [innerHTML]="$safeNavigationMigration(modelSize?.Hbox)"></span>
            }
          </div>
        }
      }
      @if (compactMode === 'semi-compact') {
        @if (!model?.IsRimless) {
          <div>
            <span class="font-medium">{{model?.Code}}</span>
          </div>
        }
        @if (model?.IsRimless) {
          <div>
            @if (!isDemo) {
              <span>{{'ENDUSER.GARNITURE'|translate}}</span>
            }
            @if (isDemo) {
              <span class="font-medium">{{model?.Code}}</span>
            }
          </div>
        }
      }
      @if (compactMode !== 'order-item' && (!model?.IsRimless || (model?.IsRimless && isDemo))) {
        <div [innerHTML]="$safeNavigationMigration(modelSize?.Hbox)"></div>
      }
      @for (componentGroup of groupedComponentSummaries; track componentGroup) {
        @for (componentText of componentGroup; track componentText) {
          <span>{{componentText}}</span>
        }
      }
      @if (configuration) {
        <span>{{configuration}}</span>
        @for (item of variantColorsToShow; track item) {
          @if (item.VariantColor) {
            <span>{{item.VariantColor.Color?.Code}}</span>
          }
        }
      }
      @if (!configuration && variantColorsToShow.length > 0) {
        @for (item of variantColorsToShow; track item) {
          @if (item.VariantColor) {
            <span>{{item.VariantColor.Color?.Code}}</span>
          }
        }
      }
    </div>
  </div>
}